<template>
    <b-modal ref="innermodal">
        <div class="select-container" :class="{open: isOpen==true, disabled: selected!=undefined}" v-on-clickaway="away">
            <div class="select-input">
                <div class="select-input-left">
                    <span class="fa fa-search" aria-hidden="true"></span>
                    <input type="text" class="form-control form-control-sm"
                           ref="input"
                           :placeholder="place"
                           v-model="keyWord"
                           @focus="onFocus" />
                </div>
                <div v-if="selected!=undefined" class="select-input-right">
                    <span class="fa fa-times-circle-o" @click="reset"></span>
                    <span class="fa fa-pencil-square-o" @click="edit"></span>
                </div>
            </div>
            <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
                <table class="table table-select">
                    <tbody>
                        <tr v-for="(ret,index) in items" :key="index" @click="select(ret)">
                            <td>{{ret.Name}}</td>
                            <td class="text-right">{{ret.Phone}}</td>
                        </tr>
                        <tr @click="add">
                            <td colspan="2" class="text-center">{{$t('create_new_customer')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <CustomerFormModal ref="form" :value="model" :link="actionLink" @done="done"></CustomerFormModal>
        </div>
    </b-modal>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    import CustomerFormModal from '../FormModal';
    import { i18n } from '../../../plugins/i18n';
    export default {
        components: { CustomerFormModal },
        mixins: [clickaway],
        props: {
            value: {
                type: String,
                default: ''
            },
            clear: {
                type: Boolean,
                default: false
            },
            place: {
                type: String,
                default: i18n.t('select')
            }
        },
        data: function () {
            return {
                keyWord: this.value,
                isOpen: false,
                customers: [],
                selected: undefined,
                actionLink: 'customer/save',
                model: undefined
            }
        },
        methods: {
            init() {
                var loading = this.$loading.show({
                    container: this.$refs.i100,
                    height: 25,
                    loader: 'dots'
                });
                var query = {
                    Text: this.keyWord,
                    Page: 1,
                    Limit: 25,
                    CompanyId: this.$store.state.company.Id
                };
                this.$api().post('customer/list', query).then(res => {
                    if (this.$isValid(res)) {
                        this.customers = res.data.Data;
                    }
                }).finally(function () { loading.hide(); });
            },
            onFocus() {
                this.$refs.input.select();
                this.isOpen = true;
                this.init();
            },
            away() {
                this.isOpen = false;
            },
            select(item) {
                if (!this.clear) {
                    this.selected = item;
                    this.keyWord = item.Name;
                } else
                    this.keyWord = '';
                this.isOpen = false;
                this.$emit('select', item);
            },
            add() {
                this.model = {
                    Name: this.keyWord,
                    Phone: ''
                };
                this.isOpen = false;
                this.$refs.form.$refs.innermodal.show();
            },
            edit() {
                var loading = this.$loading.show();
                this.$api().post('customer/find', { Id: this.selected.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Data;
                        this.actionLink = 'customer/update';
                        this.$refs.form.$refs.innermodal.show();
                    }
                }).finally(function () { loading.hide(); });
            },
            done(item) {
                this.init();
                this.model = undefined;
                this.selected = item;
                this.keyWord = item.Name;
            },
            reset() {
                this.model = undefined;
                this.selected = undefined;
                this.keyWord = '';
                setTimeout(() => { this.$refs.input.focus(); }, 0)
            }
        },
        computed: {
            items() {
                return this.customers.filter(item => {
                    return (this.keyWord == '' || item.Name.toLowerCase().includes(this.keyWord.toLowerCase()) || item.Phone.replace(' ', '').includes(this.keyWord.replace(' ', '')))
                });
            }
        },
        watch: {
            value(val) {
                this.keyWord = val;
            }
        }
    }
</script>
<style scoped>
    .select-container {
        position: relative;
        border: 1px solid #ddd;
        border-radius: 3px;
    }

        .select-container .select-input {
            display: flex;
            align-items: center;
        }

            .select-container .select-input .select-input-left {
                flex-grow: 1;
            }

            .select-container .select-input .select-input-right span {
                padding: 8px;
                width: 30px;
                text-align: center;
                cursor: pointer;
                color: green;
                line-height: 12px;
            }

                .select-container .select-input .select-input-right span:hover {
                    border-color: #ddd;
                    background: #f2f2f2;
                }

        .select-container.disabled,
        .select-container .form-control[disabled] {
            background: #fff;
        }

        .select-container .form-control {
            padding-left: 30px;
            border: none;
            border-radius: 0;
        }

        .select-container .fa-search {
            position: absolute;
            left: 10px;
            top: 8px;
            color: #737373;
        }

        .select-container .select-dropdown {
            position: absolute;
            max-height: 300px;
            border: 1px solid #e4e7ea;
            border-radius: 3px;
            display: none;
            width: 100%;
            background: #fff;
            overflow: auto;
            z-index: 10;
        }

        .select-container.open .select-dropdown {
            display: block;
            margin-top: 2px;
            z-index: 10;
        }

        .select-container .table-select {
            width: 100%;
        }

            .select-container .table-select tbody tr td {
                padding: 3px 8px;
                border: none;
            }

            .select-container .table-select tbody tr:hover {
                background: #f2f2f2;
                cursor: pointer;
            }
</style>